import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MaterialModule } from './material/material.module'; // Import MaterialModule
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginComponent } from './common/login/login.component';
import { SideNavComponent } from './components/side-nav/side-nav.component';
import { AuthService } from './auth.service';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AuthInterceptorService } from './interceptor/auth-interceptor.service';
import { ReviewsModule } from './components/reviews/reviews.module';
import { DashboardModule } from './components/dashboard/dashboard.module';
import { BookingsModule } from './components/bookings/bookings.module';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { LoaderComponent } from './common/loader/loader.component';
import { LoaderInterceptor } from './interceptor/loader.interceptor';
import { PaginationService } from './helpers/pagination.service';
import { CommonService } from './helpers/common.service';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { SelectCompanyOrgComponent } from './common/select-company-org/select-company-org.component';

// registerLocaleData(localeNl, 'en-EN');

@NgModule({
  declarations: [AppComponent, 
    LoginComponent, 
    SideNavComponent, 
    LoaderComponent, 
    SelectCompanyOrgComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule, // Import here
    FormsModule, 
    ReactiveFormsModule, 
    MaterialModule,
    HttpClientModule,
    ReviewsModule,
    DashboardModule,
    BookingsModule,
    MatPaginatorModule,
  ],
  providers: [
    AuthService,CommonService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true
    },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true }, 
    { provide: MatPaginatorIntl, useClass: PaginationService }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }
